<template>
  <app-shell :loading="true">
    <div class="create-service px-5">
      <form @submit.prevent="createService">
        <div class="align-items-start create-service__toolbar d-flex fixed-top justify-content-between row no-gutters mb-5">
          <div class="col-md-5">
            <h3 class="mb-2 create-service__title text-left">Let's get you all setup</h3>
            <p class="create-service__sub-title mt-1 text-muted text-left">
              You require to setup a service and assign it payment options in order to
              start collecting payments on mula checkout
            </p>
          </div>

          <div class="col-md-7">
            <div class="align-items-start d-flex justify-content-end ml-btn-group pt-1">
              <button class="ml-btn ml-btn--md tingg-primary-button" type="submit">Create</button>
              <button class="ml-btn ml-btn--md ml-btn--white"
                      type="button"
                      @click="quitCreatingService">
                Cancel
              </button>
            </div>
          </div>
        </div>

        <div class="no-gutters row space-from-fixed-top">
          <ml-step custom-class="col-12" step="1" sub-title="Provide information of the service your users will be paying" title="Create service">
            <div class="row no-gutters mt-3 mb-4">
              <div class="col-6">
                <div :class="{'form-group': true, 'has-error': errors.has('service_name') }">
                  <input v-validate="'required|min:3'"
                         class="mula-form-group__input form-control"
                         id="service_name"
                         name="service_name"
                         placeholder="Service name"
                         type="text"
                         autocomplete="service_name"
                         v-model="service_name"
                  >
                  <span v-show="errors.has('service_name')" class="help is-danger">
              {{ errors.first('service_name') }}
            </span>
                </div>
              </div>
            </div>
          </ml-step>
        </div>
      </form>

      <div class="mt-4 no-gutters row">
        <ml-step custom-class="col-12"
                 step="2"
                 sub-title="Pick the payment options and type of payment method you want your users to use"
                 title="Select Payment options">
          <!-- Payment options grouped by country -->
          <div class="ml-pol">
            <div v-for="country in options" class="ml-pol__item">
              <div class="ml-pol__item__title">
                {{ country.title }}
              </div>

              <ul class="ml-pol__item-list">
                <li v-for="option in country.options" class="ml-pol__item-list__item">
                  <payment-option-manager
                    :image-source="`${logoUrls['KE']}/${option.clientLogo}`"
                    :selected="option.optionEnabled"
                    :title="option.clientDisplayName"
                    :payment-option="option"
                    @option-activated="addPaymentOption"
                    @option-deactivated="removePaymentOption"
                    @option-updated="updatePaymentOption"
                  ></payment-option-manager>
                </li>
              </ul>
            </div>
          </div>
          <!-- End of the payment options list -->
        </ml-step>
      </div>
    </div>
  </app-shell>
</template>


<script>
  import _ from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import Button from '@/components/Button'
  import Config from '@/api/config'
  import Group from '@/components/Group'
  import Shell from '@/components/Shell'
  import Step from '@/components/Step'
  import Service from '@/api/services/service'
  import PaymentOptionManager from '@/components/PaymentOptionManager'
  import PaymentOptions from '@/api/services/paymentOption'

  const logInfo = process.env.NODE_ENV !== 'production'

  export default {
    components: {
      'ml-button': Button,
      'app-shell': Shell,
      'ml-group': Group,
      'ml-step': Step,
      'payment-option-manager': PaymentOptionManager
    },

    computed: {
      ...mapGetters('user', ['clientInfo']),
      hasOtherServices () {
        const services = JSON.parse(localStorage.getItem('services')) === null ? {} : JSON.parse(localStorage.getItem('services'))
        return !(services.serviceDetails === undefined || _.keys(services.serviceDetails).length < 1)
      },

      logoUrls () {
        return Config.LOGO_URLS
      }
    },

    data () {
      return {
        service_name: '',
        options: [],
        selected_options: []
      }
    },

    methods: {
      ...mapActions('auth', ['logout']),
      ...mapActions('services', ['addService']),
      addPaymentOption (option) {
        logInfo && console.log(
          'Add the payment option =>',
          _.pick(option, ['countryPayerClientID', 'clientDisplayName', 'selectedPaymentModeID', 'countryName'])
        )
        this.$set(option, 'optionEnabled', true)
        this.selected_options.push(option)
      },
      createService () {
        this.$btn.disable('button[type="submit"]')
        this.$validator.validateAll()
          .then(result => {
            logInfo && console.log('Did the service parameters pass validation ?', result)
            if (result) {
              Service.create({
                payload: {
                  'serviceName': this.service_name,
                  'clientCode': this.clientInfo.client_code,
                  'options': this.selected_options
                }
              }).then(response => {
                logInfo && console.log('Creation of a service was a success. Response =>', response)
                this.addService(_.pick(response.DATA, ['serviceName', 'serviceCode', 'serviceID']))
                this.$btn.enable('button[type="submit"]')
                this.$router.push('/home')
              }).catch(reason => {
                logInfo && console.log('Creation of a service failed. Reason =>', reason)
                this.$btn.enable('button[type="submit"]')
              })
            }
          })
          .catch(reason => {
            logInfo && console.log('Validation of the parameters failed. Reason => ', reason)
          })
      },
      logoutUser () {
        this.logout()
        this.$router.push('/login')
      },
      removePaymentOption (option) {
        logInfo && console.log(
          'Remove the payment option =>',
          _.pick(option, ['countryPayerClientID', 'clientDisplayName', 'selectedPaymentModeID', 'countryName'])
        )
        this.$set(option, 'optionEnabled', false)
        _.remove(this.selected_options, (opt) => {
          return opt.clientCode === option.clientCode
        })
      },
      quitCreatingService () {
        if (this.hasOtherServices) {
          this.$router.go(-1)
        } else {
          this.logoutUser()
        }
      },
      updatePaymentOption (option) {
        logInfo && console.log(
          'Update the payment option =>',
          _.pick(option, ['countryPayerClientID', 'clientDisplayName', 'selectedPaymentModeID', 'countryName'])
        )
        this.removePaymentOption(option)
        this.addPaymentOption(option)
      }
    },

    mounted () {
      PaymentOptions.all()
        .then(paymentOptions => {
          logInfo && console.log('Successfully fetched the payment options: ', paymentOptions)
          this.options = paymentOptions
        })
        .catch(reason => {
          logInfo && console.log('Failed to fetch the payment options: => ', reason)
        })
    },

    name: 'CreateService'
  }
</script>


<style lang="scss" scoped>
  @import "../styles/theme";

  .ml-create-service__title {
    margin: 0;
  }

  .create-service__title {
    /*font-size: 1.5rem;*/
  }

  .create-service__sub-title {
    font-size: 1rem;
  }

  .space-from-fixed-top {
    margin-top: 10rem !important
  }

  .create-service__toolbar {
    background: $background-white;
    box-shadow: 0 0 0 1px rgba(50, 50, 93, 0.1), 0 2px 5px 0 rgba(50, 50, 93, 0.08), 0 1px 1.5px 0 rgba(0, 0, 0, 0.07), 0 1px 2px 0 rgba(0, 0, 0, 0.08), 0 0 0 0 transparent;
    padding: 1.5rem 4rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/CreateService.vue